import {
  Box,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface LookupFormProps {
  open: boolean;
  dialogTitle: string;
  onClose: () => void;
  getFormSection: () => React.ReactNode;
}

const LookupForm: React.FC<LookupFormProps> = ({
  open,
  onClose,
  dialogTitle,
  getFormSection,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      id="lookup_form_dialog"
      data-test-id="lookup_form_dialog"
      aria-label="Lookup form dialog"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
        }}
        id="lookup_form_dialog_title"
        data-test-id="lookup_form_dialog_title"
        aria-label="Lookup form dialog title"
      >
        {dialogTitle}
        <IconButton 
          onClick={onClose} 
          size="small"
          id="lookup_form_dialog_close_button"
          data-test-id="lookup_form_dialog_close_button"
          aria-label="Close lookup form dialog"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        sx={{ p: 3 }}
        id="lookup_form_dialog_content"
        data-test-id="lookup_form_dialog_content"
        aria-label="Lookup form dialog content"
      >
        <Box>
          <CardContent 
            sx={{ display: "grid", gap: "10px" }}
            id="lookup_form_dialog_card_content"
            data-test-id="lookup_form_dialog_card_content"
            aria-label="Lookup form dialog card content"
          >
            {getFormSection()}
          </CardContent>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LookupForm;
